export default __webpack_public_path__ + "static/media/icon-infusion-bottle-full.7666fd98.svg";